// Web = OP styles
export function filterStyles(style = {}) {
  return style;
}
